var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.489,
    height: 17.145,
    viewBox: "0 0 12.489 17.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-width:1.5px;}.a,.b{stroke:#20bead;}.b{fill:#20bead;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M81.745,0A5.5,5.5,0,0,0,76.25,5.495c0,3.786,4.933,9.734,5.143,9.986a.458.458,0,0,0,.7,0c.21-.252,5.143-6.2,5.143-9.986A5.5,5.5,0,0,0,81.745,0Z",
    transform: "translate(-76.25)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.556 3.556)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.189,90a1.939,1.939,0,1,0,1.939,1.939A1.941,1.941,0,0,0,168.189,90Zm0,3.232a1.293,1.293,0,1,1,1.293-1.293A1.294,1.294,0,0,1,168.189,93.232Z",
    transform: "translate(-166.25 -90)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f0b8550d.svg";
export { ForwardRef as ReactComponent };